import { render, staticRenderFns } from "./SimulacrumAssessmentStep.vue?vue&type=template&id=503fef4a"
import script from "./SimulacrumAssessmentStep.vue?vue&type=script&lang=js"
export * from "./SimulacrumAssessmentStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports